// Header starts
document.addEventListener("DOMContentLoaded", function () {
  const detailsElements = document.querySelectorAll(".fl_header-parent__details");

  detailsElements.forEach(details => {
    const summary = details.querySelector("summary");

    if (summary) {
      summary.addEventListener("click", function (e) {
        if (window.innerWidth > 990) {
          setTimeout(() => {
            details.setAttribute("open", "open");
          }, 0);
        }
      });
    }
  });
});


$(document).ready(function() {
  function initMobileMenu() {
    if ($(window).width() < 990) {
      $('.fl_menu-parent__c > details > summary').off('click').on('click', function(e) {
        e.preventDefault();
        
        const $currentDetails = $(this).closest('details');
        const $currentChild = $currentDetails.find('.fl_menu-child');
        const $currentIcon = $(this).find('.fl_menu-prent__icon');
        const isOpen = $currentChild.is(':visible');
        
        $('.fl_menu-parent__c > details').each(function() {
          if (this !== $currentDetails[0]) {
            $(this).find('.fl_menu-child').stop(true, true).slideUp(300);
            $(this).find('.fl_menu-prent__icon').removeClass('active');
            $(this).removeProp('open');
          }
        });
        
        if (isOpen) {
          $currentChild.stop(true, true).slideUp(300);
          $currentIcon.removeClass('active');
          $currentDetails.removeProp('open');
        } else {
          $currentChild.stop(true, true).hide().slideDown(300);
          $currentIcon.addClass('active');
          $currentDetails.prop('open', true);
        }
      });
    } else {
      $('.fl_menu-parent__c > details > summary').off('click');
      $('.fl_menu-parent__c > details').each(function() {
        $(this).find('.fl_menu-child').show();
        $(this).find('.fl_menu-prent__icon').removeClass('active');
        $(this).prop('open', false);
      });
    }
  }
  
  initMobileMenu();
  
  $(window).on('resize', function() {
    initMobileMenu();
  });
});
// Header ends



// FL Tabs starts
document.addEventListener("DOMContentLoaded", function () {
  const buttons = document.querySelectorAll(".fl_tabs-tab__button");
  const texts = document.querySelectorAll(".fl_tabs-text");
  const images = document.querySelectorAll(".fl_tabs-image");

  buttons.forEach(button => {
    button.addEventListener("click", function () {

      const tab = this.dataset.tab;
      buttons.forEach(btn => btn.classList.remove("active"));
      this.classList.add("active");

      texts.forEach(text => {
        text.classList.remove("active");
        if (text.dataset.text === tab) {
          text.classList.add("active");
        }
      });

      images.forEach(image => {
        image.classList.remove("active");
        if (image.dataset.image === tab) {
          image.classList.add("active");
        }
      });
    });
  });
});
// FL Tabs ends
